import React from 'react';
import { loadTheme, getTheme } from 'office-ui-fabric-react/lib/Styling';

loadTheme({
    palette: {
        // MAIN_COLORS
        black: 'rgb(0,0,0)', // #000
        white: 'rgb(255,255,255)', // #FFF
        blue: 'rgb(0,111,249)', // #006FF9              notification.unread.backgroundColor

        grayLighter: 'rgb(244, 244, 246)', //  #F4F4F6  document.text.active.backgroundColor
        grayLight: 'rgb(232, 231, 233)', // #E8E7E9     area.active.backgroundColor
        gray: 'rgb(209, 209, 211)', // #D1D1D3          control.disabled.complementaryBackgroundColor
        grayDark: 'rgb(117, 117, 122)', // #75757A

        greenLight: 'rgb(11, 166, 92)', // #0BA65C
        blueHighlight: 'rgb(167, 228, 250)', // #a7e4fa

        // MAIN_THEME
        themeLight: 'rgb(247, 246, 247)', // #F7F6F7    area.default.complementaryBackgroundColor

        // HEADER
        primaryHeader: 'rgb(25,24,35)', // #191823
        primaryHeaderHover: 'rgb(76, 75, 83)', // #4C4B53
        primaryHeaderActive: 'rgba(255,255,255,0.35)', // #64636A

        // TEXT
        darkText: 'rgb(17,16,25)', // #111019           control.default.complementaryStrokeColor
        darkerText: 'rgb(20,20,20)', // #141414
        clauseLibraryText: 'rgba(36,35,33,1)', // #242321

        // BOX_SHADOW
        boxShadow: 'rgba(0,0,0,0.2)',
        boxShadowDark: 'rgba(0,0,0,0.5)',

        // BORDER
        defaultBorder: 'rgb(117, 116, 123)', // #75747B
        darkBorder: 'rgba(25,24,35,0.6)', // control.focus.complementaryForegroundColor
        disabledBorder: 'rgb(201, 201, 203)', // #C9C9CB

        // TEXTFIELD
        textFieldPlaceholder: 'rgb(186, 185, 189)', // #BAB9BD grayLabel control.disabled.foregroundColor
        blackGray: 'rgb(51, 51, 51)',
        // DIVIDER
        dividerBackground: 'rgba(25,24,35,0.15)',

        // ICONS
        primaryIconSolid: 'rgb(112, 112, 117)', // #707075  complementaryForegroundColor
        primaryIconHover: 'rgba(112, 112, 117, 0.7)',
        noClausesIcon: 'rgba(91,139,255,1)', // #5B8BFF     control.focus.complementaryStrokeColor

        // MULTISELECT
        MultiSelectItemHover: 'rgb(232, 231, 233)', // #E8E7E9      control.hover.complementaryForegroundColor suggested clauses hover
        MultiSelectItemChecked: 'rgb(209, 209, 211)', // #D1D1D3    control.disabled.complementaryBackgroundColor
        MultiSelectCheckboxBorder: 'rgba(17,16,25,0.6)', // control.focus.complementaryForegroundColor
        MultiSelectBoxShadow: 'rgba(0,0,0,0.19)',

        // LISTS/TABLES
        hoverState: 'rgba(17,16,25,0.1)', // #E7E7E8
        activeState: 'rgba(17,16,25,0.2)', // #CFCFD1

        // PRIMARY BUTTONS
        primaryDefault: 'rgb(0,111,249)', // #006FF9
        primaryHover: 'rgb(27, 93, 221)', // #1B5DDD
        primaryActive: 'rgb(31, 68, 182)', // #1F44B6
        primaryDisabled: 'rgb(191, 219, 254)', // #BFDBFE

        // SECONDARY BUTTONS
        secondaryDefault: 'rgb(255, 255, 255)', // #FFF
        secondaryHover: 'rgb(243, 243, 243)', // #F3F3F3    IconHover
        secondaryActive: 'rgb(231, 231, 232)', // #E7E7E8   IconActive
        secondaryDisabled: 'rgb(255, 255, 255)', // #FFF     IconDisabled

        //
        darkGray: '#1e1e1e',
        lightGray: '#868686',
        azure: '#005cb9',
        lightAzure: '#2463d1',
        ultraLightGray: '#e0e0de',
        paperWhite: '#f7f6f7' //      area.default.complementaryBackgroundColor
    }
});

export const theme = getTheme();
export const ThemeContext = React.createContext();
export const ThemeProvider = ThemeContext.Provider;
